import { useUpdateProfilePasswordMutation } from "../../../Store/Builder/techsbook.api";
import showToast from "../../Hooks/toast";
import { setLoader } from "../../../Store/Slice/techsbookSlice";

const { useDispatch } = require("react-redux");

const useUpdatePasswordApi = () => {
  const dispatch = useDispatch();
  const [updatePassword] = useUpdateProfilePasswordMutation();
  const send = (data) => {
    dispatch(setLoader(true));
    updatePassword(data)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success", "success");
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useUpdatePasswordApi;
